import React from 'react';
import { Hero } from '../components/home/Hero';
import { References } from '../components/home/References';
import { WhatIsDTech } from '../components/home/WhatIsDTech';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { AvailabilityDelivery } from '../components/home/AvailabilityDelivery';
import { WhyDTechUnified } from '../components/home/WhyDTechUnified';
import { Applications } from '../components/home/Applications';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-804">
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-805" />
      <References data-id="element-806" />
      <WhatIsDTech data-id="element-807" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-808" />
      <AvailabilityDelivery onRequestQuote={() => onRequestQuote()} data-id="element-809" />
      <WhyDTechUnified data-id="element-810" />
      <Applications data-id="element-811" />
    </main>;
}